module.exports = __webpack_public_path__ + "images/2e655e2d7ed69417748539fd4df4dc2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/thesuperlatives-characters00.jpg
// module id = ./webpack/assets/img/thesuperlatives-characters00.jpg
// module chunks = 0